<template>
  <transition name="slide">
    <nav v-if="toggleMenu" role="navigation" class="position-absolute w-100">
      <b-nav vertical class="w-100">
        <b-nav-item
          v-for="(navlink, index) in navLinks"
          :key="index"
          :to="{ name: navlink.name }"
          class="w-100 mobile-links"
          @click="$emit('closeMenu')"
        >
          <span class="nav-link-titel">
            {{ navlink.meta.title | uppercase }}
          </span>
        </b-nav-item>
        <b-nav-item
          class="w-100 login-mobile-nav text-uppercase"
          @click="openLoginModal"
        >
          Log ind
        </b-nav-item>
      </b-nav>

      <absi-modal modal-name="login-modal" :hideHeader="true">
        <div class="login-content-wrapper">
          <close-modal-button @clickButton="closeModal"></close-modal-button>
          <b-row align-v="center">
            <b-col>
              <h6 class="login-title text-uppercase">absi log ind</h6>
            </b-col>
          </b-row>
          <LoginForm captcha-size="compact" />
        </div>
      </absi-modal>

      <div @click="$emit('closeMenu')" variant="outline" class="w-100 h-100">
        <b-container>
          <b-row align-v="center">
            <b-col class="d-flex justify-content-center menu-btn-col">
              <b-button class="menu-icon-btn" variant="outline">
                <b-icon-chevron-double-up
                  class="menu-icon-up"
                ></b-icon-chevron-double-up>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </nav>
  </transition>
</template>

<script>
import AbsiModal from "@/components/AbsiModal.vue";
import LoginForm from "@/components/authentication/LoginForm.vue";
import CloseModalButton from "@/components/CloseModalButton.vue";

export default {
  name: "MobileNav",
  components: {
    AbsiModal,
    LoginForm,
    CloseModalButton,
  },
  props: {
    navLinks: {
      type: Array,
      required: true,
    },
    toggleMenu: {
      type: Boolean,
      required: true,
    },
    errorMsg: {
      type: Boolean,
    },
  },
  data() {
    return {
      ifErrorOpenModal: false,
      windowWidth: window.innerWidth,
      isMobile: true,
    };
  },
  watch: {
    errorMsg() {
      if (this.errorMsg) {
        this.ifErrorOpenModal = true;
      }
    },
    windowWidth() {
      this.checkingWindowWidth();
    },
  },
  updated() {
    if (this.isMobile) {
      this.openLoginModalError();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize); // Adding event listener on resize and adding data to function
      this.checkingWindowWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize); // Removing event listener on resize, and adding data to function
  },
  methods: {
    checkingWindowWidth() {
      if (this.windowWidth > 974) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    openLoginModalError() {
      if (this.ifErrorOpenModal) {
        this.$root.$emit("bv::show::modal", "login-modal", "#btnShow");
        this.ifErrorOpenModal = false;
      }
    },
    openLoginModal() {
      this.$root.$emit("bv::show::modal", "login-modal", "#btnShow");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "login-modal", "#btnHide");
    },
  },
};
</script>

<style lang="scss" scoped>
// Transition for opening and closing the menu
.slide-enter-active {
  transition: 0.4s ease-in;
}
.slide-leave-active {
  transition: 0.2s ease-out;
}
.slide-enter-to,
.slide-leave {
  max-height: 700px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

// Displaying the primary color for the current active link in the nav
.router-link-exact-active {
  border-left: 5px solid $primary !important;
  text-decoration: underline;
}

nav {
  z-index: 999;
  background-color: white;
  height: 100vh;

  .menu-icon-btn {
    .menu-icon-up {
      color: $primary;
    }
  }
}
.login-content-wrapper {
  padding: 15px;
  .login-title {
    color: $senary;
  }
}

// UL element, named by bootstrap
.nav {
  background-color: white;
  margin-top: 2px;
  right: 0;
  top: 0;

  .nav-item {
    text-align: left;
    border-bottom: $border-header;
    font-family: $medium;
  }

  // The style for the links on mobile
  .mobile-links {
    .nav-link {
      color: $primary;
      border-left: 5px solid $secondary;
    }
  }

  // The Login Button
  .login-mobile-nav {
    background-color: $primary;

    .nav-link {
      color: white;
      border-bottom: $border-header;
      text-align: center;

      &:hover,
      &:focus,
      &:active {
        background: $rgba-primary-1 !important;
      }
    }
  }
}
.mobile-form-wrapper {
  list-style-type: none;
  padding: 0;
}
.menu-btn-col {
  height: 200px;
  background-color: $secondary;
}
</style>